export enum CreditCalculationModel {
  Legacy = 'legacy',
  CostBased = 'cost_based',
}

export enum BillableUsageEventType {
  PagesProcessed = 'pages_processed',
  KimThreadCreated = 'kim_thread_created',
  KimInvocation = 'kim_invocation',
}
